module.exports = __webpack_public_path__ + "static/media/cc-amazon-pay.29295714.svg";